import React from "react";
import { ExpandButton } from "@components/buttons/expand";
import { Link, useTheme } from "@mui/material";
import { MSMessageTemplates } from "@pages/managed-accounts/model-screener/constant";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";

export const MSTableQuickLinkCell = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    const { palette } = useTheme();

    return (
      <Link
        sx={{
          paddingX: 0.5,
          cursor: "pointer",
        }}
        href={cellData.value}
        target={"_blank"}
        title={MSMessageTemplates.QuickLinkTooltip}
      >
        <ExpandButton width={"15px"} fillColor={palette.primary.dark} />
      </Link>
    );
  },
);
